import { useCallback } from 'react';
import { RootState } from 'store';

import { useSelector } from 'react-redux';

import { binarySearch } from 'common/utils';

import { EMPTY_ARRAY } from 'common/constants';
import { STATIONS_STATE } from '../../constants';

export const useRouteStationsPrices = () => {
  const routeStationsPrices = useSelector((state: RootState) => state[STATIONS_STATE].routeStationsPrices.data);
  return routeStationsPrices;
};

export const useGetRouteStationsPricesByStationCode = () => {
  const routeStationsPrices = useRouteStationsPrices() || EMPTY_ARRAY;

  const getRouteStationsPricesByStationCode = useCallback(
    (stationCode: string) => binarySearch({ key: 'stationInternalId', value: stationCode }, routeStationsPrices),
    [routeStationsPrices]
  );

  return getRouteStationsPricesByStationCode;
};

export const useRouteStationsPricesByStationCode = (stationCode: string) => {
  const getRouteStationsPricesByStationCode = useGetRouteStationsPricesByStationCode();

  return getRouteStationsPricesByStationCode(stationCode);
};

export const useMarkerServiceStations = () => {
  const markerServiceStations = useSelector((state: RootState) => state[STATIONS_STATE].markerServiceStations.data);
  return markerServiceStations;
};

export const usePriceServiceMapData = () => {
  const priceServiceMapData = useSelector(
    (state: RootState) => state[STATIONS_STATE].markerServiceStations.priceServiceMapData
  );
  return priceServiceMapData;
};
